import React from 'react';
import { CTAButton } from './CTAButton';
import { SparklesIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-[#0d1b2a] py-12 md:py-20 px-4 relative overflow-hidden" data-id="element-89">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-blue-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-90"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-91">
        <div className="inline-flex items-center gap-2 bg-blue-900/50 border border-blue-500/30 text-blue-300 px-4 py-1.5 rounded-full text-sm font-bold mb-6 uppercase tracking-wider animate-pulse" data-id="element-92">
          <SparklesIcon className="w-4 h-4" data-id="element-93" />
          Oferta Especial de Lanzamiento
        </div>

        <h1 className="text-4xl md:text-6xl font-black text-white mb-8 leading-tight uppercase drop-shadow-lg" data-id="element-94">
          SISTEMA COMPLETO DE{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-200" data-id="element-95">
            0 A INSTALADOR DE CÁMARAS
          </span>
        </h1>

        <div className="mb-10 flex justify-center relative" data-id="element-96">
          {/* Image glow */}
          <div className="absolute inset-0 bg-blue-500/20 blur-2xl rounded-full transform scale-90" data-id="element-97"></div>
          <a href="https://pagos.avanzalab.online/cart/53128638628154:1" className="block w-full max-w-3xl hover:scale-[1.02] transition-transform duration-500 relative z-10" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/is3vrayzDXsoCupevEPZBP/Diseno_sin_titulo_(4).png" alt="Sistema Completo de 0 a Instalador de Cámaras" className="w-full h-auto rounded-xl shadow-[0_0_40px_rgba(37,99,235,0.3)] border border-blue-900/50" data-id="element-99" />
          </a>
        </div>

        <p className="text-xl md:text-2xl text-gray-200 font-medium mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-100">
          El método paso a paso para aprender a instalar, configurar y empezar a
          ofrecer este servicio con seguridad, aunque hoy arranques desde cero.
        </p>

        <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-101">
          Aunque hoy no tengas experiencia, no sepas qué comprar y todavía no te
          animes a ofrecer este servicio.
        </p>

        <div className="bg-gradient-to-b from-yellow-500/10 to-transparent border-2 border-yellow-400/80 rounded-xl p-6 inline-block mb-8 shadow-[0_0_30px_rgba(234,179,8,0.15)] relative overflow-hidden group" data-id="element-102">
          <div className="absolute inset-0 bg-yellow-400/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-103"></div>
          <p className="text-2xl md:text-3xl font-bold text-white relative z-10 flex flex-col md:flex-row items-center gap-2 md:gap-4" data-id="element-104">
            <span data-id="element-105">Acceso completo hoy por solo</span>
            <span className="flex items-center gap-3" data-id="element-106">
              <span className="text-gray-400 line-through text-xl md:text-2xl decoration-red-500/50" data-id="element-107">
                $49.990
              </span>
              <span className="text-red-500 text-4xl md:text-5xl font-black drop-shadow-md" data-id="element-108">
                $29.990
              </span>
            </span>
          </p>
        </div>

        <div data-id="element-109">
          <CTAButton data-id="element-110">QUIERO ACCEDER AHORA</CTAButton>
        </div>
      </div>
    </section>;
}